// An attribute may arrive as `{ id, value, text }` (job ad / template) or `{ id, text }`
// (skills bank). The removal key is `value` when present, else `id`; the label is `text`.
export const attributeKey = (attribute) => attribute?.value ?? attribute?.id;
export const attributeLabel = (attribute) => attribute?.text ?? attribute?.label ?? String(attributeKey(attribute) ?? '');
